<template>
    <div class="warp">
        <div class="echarts" ref="echarts"></div>
    </div>
</template>
<script>
import echarts from 'echarts'
export default {
    name: 'echartsLine',
    props: ['shopUserDatas'],
    data() {
        return {
            cumulativeusersYdata: [5, 7, 8, 10, 15, 19, 17, 18, 14, 12, 6, 7],
            newcustomerLineChartYdata: [3, 5, 6, 9, 12, 16, 15, 11, 8, 5, 3, 1],
            activeUsersYdata: [7, 4, 5, 2, 14, 17, 9, 13, 18, 15, 13, 11],
            xdisplaydata: []
        }
    },
    watch: {
        shopUserDatas(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                this.initChart(this.shopUserDatas)
            })
        }
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    mounted() {},
    methods: {
        initChart(datas) {
            this.xdisplaydata = datas[0].xdisplaydata
            this.cumulativeusersYdata = datas[1].cumulativeusersYdata
            this.newcustomerLineChartYdata = datas[2].newcustomerLineChartYdata
            this.activeUsersYdata = datas[3].activeUsersYdata
            this.chart = echarts.init(this.$refs.echarts)
            this.chart.setOption(this.getOption())
        },
        getOption: function() {
            return {
                color: ['#409EFF', '#67C23A', '#FACC14'],
                // title: {
                //     subtext: '流量趋势',
                //     left: 'left',
                //     subtextStyle: {
                //         color: '#606266'
                //     }
                // },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['累计用户', '新增用户', '活跃用户'],
                    // icon: 'circle', // 圆
                    icon: 'diamond', // 菱形
                    itemWidth: 10, // 设置宽度
                    itemHeight: 10 // 设置高度
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            show: false
                        }
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    axisLabel: {
                        color: '#545454' // 刻度线标签颜色
                    },
                    data: this.xdisplaydata
                },
                yAxis: {
                    type: 'value',
                    name: '',
                    // nameTextStyle: {
                    //     color: 'red'
                    // },
                    axisLabel: {
                        color: '#545454' // 刻度线标签颜色
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: ['#f2f2f2'],
                            type: 'dashed'
                        }
                    }
                },
                series: [
                    {
                        name: '累计用户',
                        type: 'line',
                        // symbol: 'circle',
                        data: this.cumulativeusersYdata
                    },
                    {
                        name: '新增用户',
                        type: 'line',
                        // symbol: 'circle',
                        data: this.newcustomerLineChartYdata
                    },
                    {
                        name: '活跃用户',
                        type: 'line',
                        // symbol: 'circle',
                        data: this.activeUsersYdata
                    }
                ]
            }
        }
    }
}
</script>
<style scoped>
.warp {
    width: 100%;
    height: 100%;
}
.echarts {
    width: 100%;
    height: 100%;
}
</style>